import * as React from 'react';
import {FunctionComponent} from 'react';
import {classNames} from '../../../Support/classNames';
import {OutdoorIntervalTableRow} from './OutdoorIntervalTableRow';
import {InfoTooltip} from '../../Utils/InfoTooltip';
import {GeoTrackInterval} from '../../../../Geo/geoTrackToIntervals';

interface OwnProps {
    intervals: GeoTrackInterval[];
    className?: string;
}

interface TableHeaderCol {
    title: string;
    unit: string | null;
    show: boolean;
}

export const OutdoorIntervalTable: FunctionComponent<OwnProps> = ({intervals, className}) => {
    return (
        <div className={classNames('card mt-3 intervaltable', className)}>
            <div className="card-title">
                <h5>
                    Intervals
                    <InfoTooltip
                        className="ms-2"
                        description="Your workout is split into intervals at moments where your speed shifted. If your speed shifted a small amount or for a small amount of time, it will be seen as an inconsistency, rather than an interval."
                    />
                </h5>
            </div>
            <table className="table">
                <thead>
                    <tr>
                        <th className={'intervaltable__cell'}>Duration</th>
                        <th className={'intervaltable__cell intervaltable__cell--rightalined'}>
                            Distance <span className="intervaltable__cell-label">(m)</span>
                        </th>
                        <th className={'intervaltable__cell intervaltable__cell--rightalined'}>
                            Ø Split <span className="intervaltable__cell-label">(/500m)</span>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {intervals.map((interval, index) => (
                        <OutdoorIntervalTableRow interval={interval} key={index} />
                    ))}
                </tbody>
            </table>
        </div>
    );
};
